import React from 'react';
import PropTypes from 'prop-types';
/*** DATA, STORE and STATE  ***/
import { compose } from 'redux';
import { connect } from 'react-redux';
/*** ROUTER  ***/

/*** STYLE  ***/
import { withStyles } from '@material-ui/core/styles';
/*** UI LIBS  ***/
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogContentText from '@material-ui/core/DialogContentText';
import Dialog from '@material-ui/core/Dialog';
/*** CONTAINERS  ***/
/*** GLOBAL COMPONENTS  ***/
import Loading from '../../components/Loading';
/*** LOCAL COMPONENTS  ***/
import Content from './Content';
/*** ELEMENTS  ***/
/*** ACTIONS & APIs ***/
import {
  createNewStudent,
  removeStudentUser,
  updateStudent,
} from '../../store/actions/studentActions';
/*** UTILS & HELPERS ***/
/*** SCREENS  ***/

const DialogContentText = withStyles(theme => ({
  root: {
    marginBottom: 10,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 600,
  },
}))(MuiDialogContentText);

const DialogContentWorking = withStyles(theme => ({
  root: {
    margin: 0,
    height: '100%',

    padding: '6rem',
  },
}))(MuiDialogContent);

class DialogModalStudent extends React.Component {
  state = {
    status: 'ready',
  };

  beginCreate = event => {
    const { item } = this.props;
    this.setState({ status: 'working' });

    this.props.createNewStudent(item);
    // .then(() => {
    //   this.setState({ status: 'done' });
    // });
    event.preventDefault();
  };

  beginUpdate = event => {
    const { item } = this.props;
    this.setState({ status: 'working' });

    this.props
      .updateStudent(item)
      .then(() => {
        this.setState({ status: 'done' });
      })
      .catch(err => console.log(`err=${err}`));
    event.preventDefault();
  };

  beginDelete = event => {
    const { item } = this.props;
    const studentId = item.uid;
    this.setState({ status: 'working' });

    this.props.removeStudentUser(studentId).then(() => {
      this.setState({ status: 'done' });
      // this.props.handleAction();
    });
    event.preventDefault();
  };

  handlePreDone = event => {
    this.setState({ status: 'ready' });
    this.props.handleDone();
  };
  handlePreAction = event => {
    this.setState({ status: 'ready' });
    this.props.handleAction();
  };

  render() {
    const { error, open, type, handleClose, handleCancel } = this.props;

    const { status } = this.state;
    const titleType = type ? type.charAt(0).toUpperCase() + type.slice(1) : '';
    const title = `${titleType} Student`;

    return (
      <Dialog
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={open}
        onClose={handleClose}
      >
        {status === 'working' && (
          <Content title={title} hasActions={false}>
            <DialogContentWorking>
              <Loading />
            </DialogContentWorking>
          </Content>
        )}
        {status === 'error' && (
          <Content title={title} hasActions={false}>
            <DialogContentWorking>{error}</DialogContentWorking>
          </Content>
        )}
        {status === 'done' && (
          <>
            {type === 'delete' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Done"
                leftAction={this.handlePreDone}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    You have successfully DELETED the Student.
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
            {type === 'create' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Done"
                leftAction={this.handlePreDone}
                rightLabel="Add Another"
                rightAction={this.handlePreAction}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    You have successfully CREATED a new Student. What would you
                    like to do now?
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
            {type === 'update' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Done"
                leftAction={this.handlePreDone}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    You have successfully UPDATED the Student Record.
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
          </>
        )}
        {status === 'ready' && (
          <>
            {type === 'delete' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Cancel"
                leftAction={handleCancel}
                rightLabel="Delete"
                rightAction={this.beginDelete}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    Are you sure you want to DELETE the Student?
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
            {type === 'create' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Cancel"
                leftAction={handleCancel}
                rightLabel="CREATE"
                rightAction={this.beginCreate}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    Are you sure you want to CREATE a New Student?
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
            {type === 'update' && (
              <Content
                title={title}
                hasActions={true}
                leftLabel="Cancel"
                leftAction={handleCancel}
                rightLabel="UPDATE"
                rightAction={this.beginUpdate}
              >
                <MuiDialogContent>
                  <DialogContentText>
                    Are you sure you want to UPDATE the Student Record?
                  </DialogContentText>
                </MuiDialogContent>
              </Content>
            )}
          </>
        )}
      </Dialog>
    );
  }
}

DialogModalStudent.propTypes = {
  open: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};
const mapStateToProps = (state, ownProps) => {
  return {
    appStatus: state.appStatus,
    sStatus: state.appStatus.status,
    error: state.appStatus.error,
    newid: state.appStatus.data.currentId,
  };
};
// export default withStyles(styles)(DialogModal);
const mapDispatchToProps = dispatch => {
  return {
    createNewStudent: sobj => dispatch(createNewStudent(sobj)),
    removeStudentUser: uid => dispatch(removeStudentUser(uid)),
    updateStudent: sobj => dispatch(updateStudent(sobj)),
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(DialogModalStudent);
